const audioContext = new (window.AudioContext || window.webkitAudioContext)();

function getAudioBufferFromUrl(url) {
    return fetch(url)
        .then(response => response.arrayBuffer())
        .then(arrayBuffer => new Promise((resolve, reject) => {
            audioContext.decodeAudioData(arrayBuffer, resolve, reject);
        }));
}

export { audioContext, getAudioBufferFromUrl };
